import { brandName, navLinks } from '@/mocks/animeData';

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-palette-line text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">{brandName}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              剧情解析、名场面盘点、角色关系梳理与分集解说，帮你快速看懂每集重点。追更解说，来这里就够了。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#home"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a
                href="#home"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#home"
                aria-label="抖音"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-music-2-line text-lg"></i>
              </a>
              <a
                href="mailto:2143051413@qq.com"
                aria-label="邮箱"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2">
              {navLinks.slice(1).map((link) => (
                <li key={link.id}>
                  <a href={`#${link.id}`} className="text-sm text-foreground-600 hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:2143051413@qq.com" className="hover:text-primary-600">2143051413@qq.com</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>每周一、三、五更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line"></i>内容投稿长期开放
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 {brandName} · 用轻松的方式，把动画看得更明白
          </p>
          <p className="text-xs text-foreground-600">内容站 · 专注剧情解析与名场面盘点</p>
        </div>
      </div>
    </footer>
  );
}